require('../components/ga-events');
const CustomSelect = require('./custom-select');
const LanguageAndCurrencySelectors = require('./language-and-currency-selectors');
const JsLinks = require('./js-links');
const Annotations = require('./annotations');
const ScrollToTop = require('./scroll-to-top');
const ExitPopup = require('./exit-popup');
const MainSearch = require('./main-search');
const MobileMenu = require('./mobile-menu');
const $ = require('cash-dom');
const DynamicData = require('../components/dynamic-data');
const Tooltip = require('../components/tooltips');
const ShareButtons = require('../components/share-buttons');
const Video = require('../components/video');
require('../components/keyboard-navigation');

const Base = {
  init() {
    const self = this;

    DynamicData.init();
    CustomSelect.init();
    LanguageAndCurrencySelectors.init();
    JsLinks.init();
    Annotations.init();
    ScrollToTop.init();
    ExitPopup.init();
    MobileMenu.init();

    const idleCallback = (cb, options = {}) => {
      if ('requestIdleCallback' in window) {
        return window.requestIdleCallback(cb, options);
      }
      // Safari
      return setTimeout(cb, 800);
    };

    idleCallback(() => {
      MainSearch.init();
      Tooltip.init();
      ShareButtons.init();
      Video.init();
    }, { timeout: 2000 });

    $('.adsbygoogle').each(function () {
      (adsbygoogle = window.adsbygoogle || []).push({});
    });

    if(document.body.textContent.includes('/go/')){
      $('.top-disclosure').show();
    }

    //dropdown-box shortcode
    $(document).on('mousedown', '.article-dropdown-box-container .dropdown-box-title', (e) => {
      e.preventDefault();

      $(e.target).closest('.article-dropdown-box-container').toggleClass('active');
    });

    $(function () {
      const $timer = $('#black-friday-timer');
      if (!$timer.length) return;

      const endTime = Number($timer.data('end'));
      if (!endTime) return;

      const $days = $timer.find('#black-friday-days'),
        $hours = $timer.find('#black-friday-hours'),
        $mins = $timer.find('#black-friday-mins'),
        $secs = $timer.find('#black-friday-secs');

      if (!$days.length || !$hours.length || !$mins.length || !$secs.length) return;

      function updateTimer() {
        const diff = endTime - Date.now();
        if (diff <= 0) return $timer.hide();

        const sec = 1000, min = sec * 60, hour = min * 60, day = hour * 24;

        $days.text(Math.floor(diff / day));
        $hours.text(Math.floor((diff % day) / hour));
        $mins.text(Math.floor((diff % hour) / min));
        $secs.text(Math.floor((diff % min) / sec));
      }

      updateTimer();
      setInterval(updateTimer, 1000);
    });
  },
};

module.exports = Base;
